import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
    typography: {
        fontFamily: '"Relaway", sans-serif',
    },
});